/**
 * Returns all css classes for the given item
 * @param {EsgItem} esgItem
 * @returns {string}
 */
function getCloserCssClasses(esgItem) {
  const esgCloseClassPrefix = 'esg-close-';

  const parentEsgItem = document.getElementById(`${esgItem.parent}-item`);

  if (parentEsgItem === null) {
    return `${esgCloseClassPrefix}root`;
  }

  const esgClasses = [esgCloseClassPrefix + esgItem.parent];

  for (let i = 0; i < parentEsgItem.classList.length; i += 1) {
    if (parentEsgItem.classList[i].startsWith(esgCloseClassPrefix)) {
      esgClasses.push(parentEsgItem.classList[i]);
    }
  }
  return esgClasses.join(' ');
}

/**
 *
 * @param {EsgItem} esgItem
 * @param {string} answers
 * @param {string} answersDebug
 * @returns {string}
 * @constructor
 */
function EsgQuestionComponent(esgItem, answers, answersDebug) {
  return `
        <div class='px-6 py-4 border-b border-gray-200 hidden overflow-hidden bg-white shadow sm:rounded-lg my-4 esg-item ${getCloserCssClasses(
          esgItem
        )}' id='${esgItem.item.id}-item' data-type='${esgItem.item.type}'>
            <div class='px-4 py-5 sm:px-6'>
            <h3 class='text-lg font-medium leading-6 text-gray-900'>${esgItem.item.title}</h3>
            ${
              esgItem.item.hint
                ? `
                <p class='mt-1 text-sm text-gray-500'>${esgItem.item.hint}</p>
            `
                : ''
            }
            </div>
            <div class='border-t border-gray-200 px-4 py-5 mt-4 flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4'>
                ${answers}
            </div>
            <div class='border-t border-gray-200 px-4 py-5 sm:p-0 esg-debug'>
                <dl class='sm:divide-y sm:divide-gray-200'>
                
                    ${Object.keys(esgItem.item)
                      .map(
                        (property) => `
                      <div class='py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6'>
                        <dt class='text-sm font-medium text-gray-500'>item.${property}</dt>
                        <dd class='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>${esgItem.item[property]}</dd>
                      </div>
                    `
                      )
                      .join('')}
                  <div class='py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6'>
                    <dt class='text-sm font-medium text-gray-500'>parent</dt>
                    <dd class='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>
                        ${
                          esgItem.parent
                            ? `
                            <a href='#${esgItem.parent}-item' class='font-medium text-indigo-600 hover:text-indigo-500'>${esgItem.parent}</a>
                        `
                            : 'null'
                        }
                    </dd>
                  </div>
                  <div class='py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6'>
                    <dt class='text-sm font-medium text-gray-500'>answers</dt>
                    <dd class='mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0'>
                      <ul role='list' class='divide-y divide-gray-200 rounded-md border border-gray-200'>
                        ${answersDebug}
                      </ul>
                    </dd>
                  </div>
                </dl>
            </div>
        </div>
    `;
}

export default EsgQuestionComponent;
